// English translations
export const en = {
  // App name
  appName: "Devi Impex",
  managementSystem: "Management System",

  // Common
  loading: "Loading...",
  save: "Save",
  saveChanges: "Save Changes",
  cancel: "Cancel",
  delete: "Delete",
  deleting: "Deleting...",
  edit: "Edit",
  create: "Create",
  add: "Add",
  addDetail: "Add Detail",
  update: "Update",
  search: "Search",
  filter: "Filter",
  clear: "Clear",
  clearFilters: "Clear Filters",
  confirm: "Confirm",
  back: "Back",
  next: "Next",
  previous: "Previous",
  yes: "Yes",
  no: "No",
  actions: "Actions",
  action: "Action",
  status: "Status",
  date: "Date",
  total: "Total",
  grandTotal: "Grand Total",
  details: "Details",
  noData: "No data available",
  error: "Error",
  success: "Success",
  warning: "Warning",
  info: "Info",
  print: "Print",
  optional: "Optional",
  required: "Required",
  selectCompany: "Select Company",
  selectProgram: "Select Program",
  selectProgramFirst: "Select Program First",
  typeToSearch: "Type to search",
  noDetailsAdded: 'No details added yet. Click "Add Detail" to start.',
  calculatedTotalRolls: "Calculated Total Rolls",
  calculatedTotalWeight: "Calculated Total Weight",
  basicInformation: "Basic Information",
  noteId: "Note ID",
  created: "Created",
  phone: "Phone",
  representative: "Representative",
  representativeName: "Representative Name",
  representativePhone: "Representative Phone",
  selectDia: "Select Dia",
  selectGauge: "Select Gauge",
  selectType: "Select Type",
  notFound: "Not Found",

  // Navigation / Sidebar
  nav: {
    home: "Home",
    companies: "Companies",
    employees: "Employees",
    machines: "Machines",
    receivedNotes: "Received Notes",
    programs: "Programs",
    deliveries: "Deliveries",
    invoices: "Invoices",
    inventory: "Inventory",
    employeeShifts: "Employee Shifts",
    metrics: "Metrics",
    productionMetrics: "Production Metrics",
    employeeMetrics: "Employee Metrics",
    viewAnalytics: "View Analytics",
    finance: "Finance",
    users: "Users",
    auditLog: "Audit Log",
    settings: "Settings",
    logout: "Logout",
    changePassword: "Change Password",
  },

  // Change Password
  changePassword: {
    title: "Change Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm New Password",
    changeButton: "Change Password",
    changing: "Changing...",
    success: "Password changed successfully",
    currentPasswordIncorrect: "Current password is incorrect",
    passwordMismatch: "New passwords do not match",
    passwordTooShort: "Password must be at least 6 characters",
    error: "Failed to change password",
  },

  // Login page
  login: {
    title: "Login",
    email: "Email",
    password: "Password",
    loginButton: "Login",
    loggingIn: "Logging in...",
    invalidCredentials: "Invalid email or password",
    loginFailed: "Login failed",
    forgotPassword: "Forgot Password?",
  },

  // Forgot Password
  forgotPassword: {
    title: "Forgot Password",
    subtitle: "Enter your email and we'll send you a reset link",
    emailPlaceholder: "Enter your email address",
    sendResetLink: "Send Reset Link",
    sending: "Sending...",
    successTitle: "Check your email",
    successMessage: "We've sent password reset instructions to your email address.",
    backToLogin: "Back to Login",
    tryAgain: "Try Again",
    errorMessage: "Unable to send reset link. Please try again.",
  },

  // Reset Password
  resetPassword: {
    title: "Reset Password",
    subtitle: "Enter your new password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    resetButton: "Reset Password",
    resetting: "Resetting...",
    successTitle: "Password Reset Successful",
    successMessage: "Your password has been reset. You can now login with your new password.",
    errorMessage: "Unable to reset password. The link may have expired.",
    invalidToken: "Invalid or expired reset link",
    passwordMismatch: "Passwords do not match",
    passwordTooShort: "Password must be at least 6 characters",
    goToLogin: "Go to Login",
  },

  // Home / Dashboard
  home: {
    title: "Machine Status Dashboard",
    inProgress: "In Progress",
    notYetStarted: "Not Yet Started",
    idle: "Idle",
    loadingMachineStatus: "Loading machine status...",
    noActivePrograms: "No active programs",
    noMachinesInCategory: "No {gauge} GG machines in this category",
    machines14GG: "14 GG Machines",
    machines16GG: "16 GG Machines",
    weight: "Weight",
    rolls: "Rolls",
    remaining: "remaining",
    completed: "Completed",
    extra: "extra",
    kgRemaining: "{value} kg remaining",
    rollsRemaining: "{value} rolls remaining",
  },

  // Companies
  companies: {
    title: "Companies",
    createNew: "Add Company",
    name: "Company Name",
    phone: "Phone",
    email: "Email",
    address: "Address",
    gst: "GST Number",
    noCompanies: "No companies found",
    deleteConfirm: "Are you sure you want to delete this company?",
    details: "Company Details",
    edit: "Edit Company",
    searchByName: "Search by company name",
    sortDefault: "Sort by Recent Programs",
    sortNameAsc: "Name (A-Z)",
    sortNameDesc: "Name (Z-A)",
  },

  // Employees
  employees: {
    title: "Employees",
    createNew: "Add Employee",
    name: "Name",
    phone: "Phone",
    role: "Role",
    noEmployees: "No employees found",
    deleteConfirm: "Are you sure you want to delete this employee?",
    details: "Employee Details",
    edit: "Edit Employee",
    monthlySalary: "Monthly Salary",
    payPerShift: "Pay Per Shift",
  },

  // Machines
  machines: {
    title: "Machines",
    createNew: "Add Machine",
    dia: "Dia",
    gauge: "Gauge",
    machineType: "Machine Type",
    rib: "Rib",
    interlock: "Interlock",
    noMachines: "No machines found",
    deleteConfirm: "Are you sure you want to delete this machine?",
    details: "Machine Details",
    edit: "Edit Machine",
  },

  // Received Notes
  receivedNotes: {
    title: "Received Notes",
    createNew: "Add Received Note",
    createTitle: "Create Received Note",
    editTitle: "Edit Received Note",
    receiptNumber: "Receipt Number",
    company: "Company",
    yarnType: "Yarn Type",
    lotNumber: "Lot Number",
    weight: "Weight",
    weightPerBag: "Weight/Bag (kg)",
    totalWeight: "Total Weight",
    totalWeightKg: "Total Weight (kg)",
    bags: "Bags",
    numberOfBags: "No. of Bags",
    counts: "Counts",
    mill: "Mill",
    color: "Color",
    colors: "Colors",
    receivedDate: "Received Date",
    noReceivedNotes: "No received notes found",
    deleteConfirm: "Are you sure you want to delete this received note?",
    details: "Received Note Details",
    edit: "Edit Received Note",
    associatedPrograms: "Associated Programs",
    associatedDeliveries: "Associated Deliveries",
    noPrograms: "No programs associated",
    noDeliveries: "No deliveries associated",
    detailNumber: "Detail #",
    selectCompanyOrEnterNew: "Type to search or enter a new company name",
  },

  // Programs
  programs: {
    title: "Programs",
    createNew: "Add Program",
    createTitle: "Create Program",
    editTitle: "Edit Program",
    programId: "Program ID",
    programNumber: "Program #",
    company: "Company",
    lot: "Lot",
    lotOptional: "Lot - Optional",
    status: "Status",
    progress: "Progress",
    totalWeight: "Total Weight",
    completedWeight: "Completed Weight",
    doneWeight: "Done Weight",
    remainingWeight: "Remaining Weight",
    numberOfRolls: "Number of Rolls",
    rollsOptional: "Rolls (Optional)",
    dia: "Dia",
    gauge: "Gauge",
    gaugeGG: "Gauge (GG)",
    type: "Type",
    weightKg: "Weight (kg)",
    design: "Design",
    texture: "Texture",
    textureOptional: "Texture (Optional)",
    noPrograms: "No programs found",
    deleteConfirm: "Are you sure you want to delete this program?",
    details: "Program Details",
    programDetails: "Program Details",
    edit: "Edit Program",
    share: "Share",
    shareProgram: "Share Program",
    shareViaSms: "Share via SMS",
    copyLink: "Copy Link",
    linkCopied: "Link copied to clipboard",
    statusNotStarted: "Not Started",
    statusPending: "Pending",
    statusInProgress: "In Progress",
    statusCompleted: "Completed",
    statusDelivered: "Delivered",
    statusCancelled: "Cancelled",
    associatedReceipts: "Associated Receipts - Optional",
    pleaseSelectCompanyFirst: "Please select a company first",
    noReceiptsForCompany: "No receipts available for selected company",
    receipt: "Receipt",
    typeToSearchCompany: "Type to search for a company",
    productionHistory: "Production History",
    employeeShiftDetails: "Employee Shift Details",
    noProductionData: "No production data available",
    shiftDate: "Shift Date",
    shiftTime: "Shift Time",
    employee: "Employee",
    noMachinesAvailable: "No machines available",
    noMachinesForSelection: "No machines for selected Gauge/Type",
    machineCombinationError:
      "This combination of Dia, Gauge, and Type does not exist in available machines",
  },

  // Deliveries
  deliveries: {
    title: "Deliveries",
    createNew: "Add Delivery",
    createTitle: "Create Delivery",
    editTitle: "Edit Delivery",
    deliveryNumber: "Delivery Number",
    deliveryId: "Delivery #",
    company: "Company",
    program: "Program",
    programLot: "Program Lot",
    deliveryDate: "Delivery Date",
    weight: "Weight",
    weightKg: "Weight (kg)",
    rolls: "Rolls",
    noDeliveries: "No deliveries found",
    deleteConfirm: "Are you sure you want to delete this delivery?",
    details: "Delivery Details",
    deliveryDetails: "Delivery Details",
    edit: "Edit Delivery",
    deliveryPersonDetails: "Delivery Person Details",
    deliveryPersonName: "Delivery Person Name",
    deliveryPersonPhone: "Delivery Person Phone",
    vehicleNumber: "Vehicle Number",
    machineType: "Machine Type",
    detailNumber: "Detail #",
  },

  // Invoices
  invoices: {
    title: "Invoices",
    createNew: "Add Invoice",
    invoiceNumber: "Invoice Number",
    company: "Company",
    invoiceDate: "Invoice Date",
    amount: "Amount",
    noInvoices: "No invoices found",
    deleteConfirm: "Are you sure you want to delete this invoice?",
    details: "Invoice Details",
    edit: "Edit Invoice",
  },

  // Inventory
  inventory: {
    title: "Inventory",
    yarnType: "Yarn Type",
    lotNumber: "Lot Number",
    weight: "Weight",
    available: "Available",
    noInventory: "No inventory items found",
  },

  // Employee Shifts
  employeeShifts: {
    title: "Employee Shifts",
    createNew: "Add Shift",
    employee: "Employee",
    machine: "Machine",
    program: "Program",
    shiftDate: "Shift Date",
    shiftType: "Shift Type",
    weight: "Weight",
    rolls: "Rolls",
    noShifts: "No employee shifts found",
    deleteConfirm: "Are you sure you want to delete this shift?",
    details: "Shift Details",
    edit: "Edit Shift",
    day: "Day",
    night: "Night",
  },

  // Metrics
  metrics: {
    productionTitle: "Production Metrics",
    employeeTitle: "Employee Metrics",
    totalProduction: "Total Production",
    averageDaily: "Average Daily",
    topPerformers: "Top Performers",
    dateRange: "Date Range",
    from: "From",
    to: "To",
    apply: "Apply",
  },

  // View Analytics
  viewAnalytics: {
    title: "View Analytics",
    subtitle: "Track how many times shared program links are viewed",
    totalViews: "Total Views",
    programsShared: "Programs Shared",
    companiesReached: "Companies Reached",
    lastViewed: "Last Viewed",
    program: "Program",
    company: "Company",
    views: "Views",
    noViews: "No shared programs have been viewed yet",
    mostViewed: "Most Viewed Programs",
    recentlyViewed: "Recently Viewed",
    viewCount: "View Count",
    lastViewedAt: "Last Viewed At",
    neverViewed: "Never Viewed",
    shareToken: "Share Token",
    lot: "Lot",
    status: "Status",
    loading: "Loading analytics data...",
    error: "Failed to load analytics data",
  },

  // Users
  users: {
    title: "Users",
    createNew: "Add User",
    inviteUser: "Invite User",
    inviteDescription: "Send an invitation email to the user. They will receive a link to set up their password.",
    sendInvitation: "Send Invitation",
    inviting: "Sending...",
    invitationSent: "Invitation sent successfully! The user will receive an email to set up their password.",
    email: "Email",
    role: "Role",
    admin: "Admin",
    user: "User",
    noUsers: "No users found",
    deleteConfirm: "Are you sure you want to delete this user?",
    details: "User Details",
    edit: "Edit User",
    password: "Password",
    confirmPassword: "Confirm Password",
  },

  // Settings
  settings: {
    title: "Settings",
    organization: "Organization Settings",
    smsSettings: "SMS Settings",
    generalSettings: "General Settings",
  },

  // Finance
  finance: {
    title: "Finance",
    revenue: "Revenue",
    expenses: "Expenses",
    profit: "Profit",
    invoiced: "Invoiced",
    estimated: "Estimated",
    salaries: "Salaries",
    revenueDetails: "Revenue Details",
    invoicedRevenue: "Invoiced Revenue",
    estimatedRevenue: "Estimated Revenue",
    rate: "Rate",
    ratePerKg: "Rate per kg (for uninvoiced)",
    delivery: "Delivery",
    company: "Company",
    weight: "Weight",
    amount: "Amount",
    noRevenueData: "No revenue data for this month",
    enterExpenses: "Enter Expenses",
    electricBill: "Electric Bill",
    needlesCost: "Needles Cost",
    repairCost: "Repair Cost",
    employeeSalaries: "Employee Salaries",
    autoCalculated: "Auto-calculated",
    shifts: "Shifts",
    payRate: "Pay Rate",
    salary: "Salary",
    shiftBased: "Shift Based",
    additionalPayments: "Additional Payments",
    bonusOvertime: "Bonus/Overtime",
    noAdditionalPayments: "No additional payments",
    addPayment: "Add Payment",
    paymentType: "Payment Type",
    noEmployees: "No employees configured",
    addSalary: "Add Salary",
    employee: "Employee",
    type: "Type",
    noSalaries: "No salaries added yet",
    saveExpenses: "Save Expenses",
    saved: "Expenses saved successfully",
    selectMonth: "Select a month to view details",
    selectEmployee: "Select Employee",
    salaryType: "Salary Type",
    monthly: "Monthly",
    bonus: "Bonus",
    overtime: "Overtime",
    other: "Other",
    otherExpenses: "Other Expenses",
    noOtherExpenses: "No other expenses added",
    description: "Description",
    notes: "Notes",
  },

  // Language
  language: {
    select: "Language",
    english: "English",
    tamil: "தமிழ்",
  },

  // Validation messages
  validation: {
    required: "This field is required",
    invalidEmail: "Invalid email address",
    minLength: "Minimum {min} characters required",
    maxLength: "Maximum {max} characters allowed",
    passwordMismatch: "Passwords do not match",
  },

  // Date/Time
  dateTime: {
    today: "Today",
    yesterday: "Yesterday",
    thisWeek: "This Week",
    thisMonth: "This Month",
    lastMonth: "Last Month",
    custom: "Custom",
  },
};

export type TranslationKeys = typeof en;
